import { resetTimeout } from '../app/timeoutSlice'
import { useDispatch } from 'react-redux'

export default function ResetTimeout() {
    const dispatch = useDispatch()
    dispatch(resetTimeout())
    return <div></div>
}